import moment from 'moment'

import { DocasContextValue } from './ContextType'

export const DocasContextInitialValues: DocasContextValue = {
  dataAtual: moment(),
  janelaAtual: 0,
  selecionados: [],
  selecaoContinua: false,
  btnAprovarSelecionados: false,
  btnBloquearSelecionados: false,
  executing: false,
  macros: [],
  macrosParaAvisar: [],
  agendamentosMultiplos: [],
  avisoPiscante: !window.sessionStorage.getItem('desativarAvisoPiscante'),
  atualizarAvisoPiscante: false,
  alertas: [],
  alertasSonoros: [],
}
